import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexRowCenter,
  FlexColCenterVertical,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';

export enum Delivery {
  ZASIELKOVNA = 'ZASIELKOVNA',
}

const Radio = styled(FlexRowCenter)`
  width: ${rem(24)};
  height: ${rem(24)};
  background: transparent;
  border: ${rem(2)} solid ${({ theme }) => theme.cartChooser.active};
  border-radius: 50%;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
`;

const InnerRadio: any = styled.div`
  width: ${rem(10)};
  height: ${rem(10)};
  background-color: ${(props: any) =>
    props.selected ? props.theme.cartChooser.active : 'transparent'};
  border-radius: 50%;
  transition: background-color 0.2s ease;
`;

const Wrapper: any = styled(FlexRowCenter)`
  width: 100%;
  height: ${rem(56)};
  /* background: ${(props: any) =>
    props.selected ? props.theme.cartChooser.active : 'transparent'}; */
  border-radius: ${rem(2)};
  margin-bottom: ${rem(8)};
  border: 1px solid #cccccc;
  transition: background-color 0.2s ease;
  padding: ${rem(16)} ${rem(24)};
  border-radius: ${rem(4)};

  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.cartChooser.bgHover};
  }

  &:hover ${InnerRadio} {
    background-color: ${props => props.theme.cartChooser.active};
  }

  ${({ theme }) => theme.mediab.l925`
    margin-bottom: ${rem(16)};
  `}
`;

const TextWrapper = styled(FlexColCenterVertical)`
  ${({ theme }) => theme.mediab.l925`
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
`;

const PriceWrapper = styled(FlexRowCenter)`
  margin-left: auto;
  justify-content: flex-start;

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.primary};
`;

const DphIndicator = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.tertiary};
  margin-left: ${rem(3)};
`;

const NamePriceWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    align-items: flex-start;
  `}
`;

const RadioWrapper = styled(FlexRowCenter)`
  margin-right: ${rem(16)};
`;

interface Props {
  item: any;
  selected: boolean;
  zasielkovna_id?: string;
  handleOptionClick: (option: any) => void;
  hasVatrate?: boolean;
}

function OptionChooserItem({
  item,
  selected,
  handleOptionClick,
  hasVatrate = true,
}: Props) {
  return (
    <Wrapper selected={selected} onClick={handleOptionClick}>
      <RadioWrapper>
        <Radio>
          <InnerRadio selected={selected} />
        </Radio>
      </RadioWrapper>
      <NamePriceWrapper>
        <TextWrapper>
          <Name>{item.name}</Name>
        </TextWrapper>
        <PriceWrapper>
          <Price>{item.price}</Price>
        </PriceWrapper>
      </NamePriceWrapper>
    </Wrapper>
  );
}

export { OptionChooserItem };
